<template>

  <div class="md-layout input-layout">
      <!-- Search Address -->
      <search-address
        :prefixLabel="prefixLabel"
        :disabled="disabled"
        :address="address"
        @update-address="updateAddress"
      ></search-address>

      <!-- Address Unit -->
      <validated-text-input class="md-layout-item md-small-size-100 md-size-10"
        label="Unit Number" v-model="address.unit"
        :prefixLabel="prefixLabel"
        :disabled="disabled"
        regex = "[0-9A-Za-z\-]*"
        >
      </validated-text-input>

      <!-- Street Number -->
      <validated-text-input class="md-layout-item md-small-size-100 md-size-10"
        label="Street Number" v-model="address.street_number"
        :prefixLabel="prefixLabel"
        :disabled="disabled"
        regex = "^[0-9A-Za-z-/]*$"
        :maxLength=15
        :errormsg="address.street_number && address.street_number.length > 15 ? 'Street Number accepts maximum 15 characters' : 'Please enter the correct information.'"
        >
      </validated-text-input>

      <!-- Street Name -->
      <validated-text-input class="md-layout-item md-small-size-100 md-size-20"
        label="Street Name" v-model="address.street_name"
        :prefixLabel="prefixLabel"
        :disabled="disabled"
        :maxLength=50
        :errormsg="address.street_name && address.street_name.length > 50 ? 'Street Name accepts only 50 characters' : 'Please enter the correct information.'"
        >
      </validated-text-input>

      <!-- Street Type -->
      <validated-autocomplete-input class="md-layout-item md-small-size-100 md-size-20"
        label="Street Type" v-model="address.street_type"
        :prefixLabel="prefixLabel"
        :disabled="disabled"
        :options="options.address_street_type"
        alpha-spaces
      />

      <!-- Suburb -->
      <validated-text-input class="md-layout-item md-small-size-100 md-size-20"
        label="Suburb" v-model="address.suburb"
        :prefixLabel="prefixLabel"
        :disabled="disabled"
        regex = "^[A-Za-z -]*$"
        :maxLength=50
        :errormsg="address.suburb && address.suburb.length>50 ? 'Suburb accept only 50 characters' : 'Please enter the correct information.'"
        >
      </validated-text-input>

      <!-- State -->
      <validated-autocomplete-input class="md-layout-item md-small-size-100 md-size-10"
        label="State" v-model="address.state"
        :prefixLabel="prefixLabel"
        :disabled="disabled"
        :options="states"
        alpha-spaces
        force
      />

      <!-- Postcode -->
      <validated-number-input class="md-layout-item md-small-size-100 md-size-10"
        label="Postcode" v-model="address.post_code"
        :prefixLabel="prefixLabel"
        :disabled="disabled"
        integer
        :minLength=4
        :maxLength=10
        :errormsg="address.post_code && address.post_code.length>10 ? 'Postcode accept only 10 digits' : 'Please enter the correct information.'"
        :required="isPostcodeRequired"
        >
      </validated-number-input>

      <!-- Country -->
      <validated-autocomplete-input class="md-layout-item md-small-size-100 md-size-15"
        label="Country" v-model="address.country"
        :prefixLabel="prefixLabel"
        :disabled="disabled"
        :options="options.countries"
        alpha-spaces
        force
      />

  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import filters from '@/components/utils/filters';
import utils from '@/components/utils/utils';
import ValidatedInputs from '@/components/ValidatedInput';
import ListItemCard from "@/components/Cards/ListItemCard.vue";
import { isAddressRentLike } from "@/components/utils/validation";
import SearchAddress from '@/components/SearchAddress.vue';

export default {
  components: {
    ...ValidatedInputs,
    ListItemCard,
    SearchAddress
  },
  data(){
    return {

    };
  },
  props: {
    value: {
      type: Object,
      default: {},
      required: true,
    },
    prefixLabel: {
      type: String,
      default: '',
    },
    disabled: false
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      options: 'options',
    }),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    address: {
      get(){ return this.value; },
      set(address){ this.$emit('input', address); },
    },

    states(){
      return this.options.country_states[this.address.country];
    },

    isPostcodeRequired() {
      return Boolean(
        this.address.full_address ||
        this.address.unit ||
        this.address.street_number ||
        this.address.street_name ||
        this.address.street_type ||
        this.address.suburb ||
        this.address.state
      );
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,
    async updateAddress(data) {
        console.log(data);
        Object.assign(this.address, data);
        this.address.country = this.options.countries[0];
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'address_street_type',
        'countries',
        'country_states',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>
